import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69e32d5b8485e20014eb8ef8/versus/src/app/categories/[slug]/page.tsx");
